import { parse } from "../utils";

export default {
  "post|MyPage/getlist": (option) => {
    const pageSize = parse("pageSize", option.url);
    let list = [];
    if (pageSize > 4) {
      list = [
        {
          cover: require("@/assets/images/c02-01-1.png"),
          link: "/research/detail",
          title: "サイバー人材需給逼迫1",
          catagory: "トレンド",
          publicDate: "2020-01-01 09:12:08",
          summary:
            "将来のサイバー人材を生み出す観点でも、日本は後れを取っている。人材派遣のヒューマンリソシア（東京・新宿）は7月、STEM（科学、技術、工学、数学）分野の卒業者数に関する調査を発表した。対象となる92の国・地域のうち、日本は13位の3万人。インド（114万人）や米国（28万人）のみならず、英国（10万人）やフランス...M（科学、技術、工学、数学）分野の卒業者数に関する調査を発表した。対象となる92の国・地域のうち、日本は13位の3万人。インド（114万人）や米国（28万人）のみならず、英国（10万人）やフランス",
          tagModel: [
            {
              itemid: "00000000-0000-0000-0000-000000000000",
              text:
                "その他変更テストその他収益性向上変更テストその他収益性向上",
              tcode: "z1_01",
              children: null,
            },
            {
              itemid: "00000000-0000-0000-0000-000000000000",
              text: "変更テスト",
              tcode: "z1_08",
              children: null,
            },
            {
              itemid: "00000000-0000-0000-0000-000000000000",
              text: "Social",
              tcode: "z1_07",
              children: null,
            },
            {
              itemid: "00000000-0000-0000-0000-000000000000",
              text: "変更テストその他収益性向上",
              tcode: "z1_09",
              children: null,
            },
          ],
        },
        {
          cover: require("@/assets/images/c02-01-2.png"),
          link: "/research/detail",
          title: "サイバー人材需給逼迫2",
          catagory: "ピックアップニュース",
          publicDate: "2020-01-01 09:12:08",
          summary:
            "将来のサイバー人材を生み出す観点でも、日本は後れを取っている。人材派遣のヒューマンリソシア（東京・新宿）は7月、STEM（科学、技術、工学、数学）分野の卒業者数に関する調査を発表した。対象となる92の国・地域のうち、日本は13位の3万人。インド（114万人）や米国（28万人）のみならず、英国（10万人）やフランス...M（科学、技術、工学、数学）分野の卒業者数に関する調査を発表した。対象となる92の国・地域のうち、日本は13位の3万人。インド（114万人）や米国（28万人）のみならず、英国（10万人）やフランス",
          tagModel: [
            {
              itemid: "00000000-0000-0000-0000-000000000000",
              text: "収益性向上",
              tcode: "z2_01",
              children: null,
            },
            {
              itemid: "00000000-0000-0000-0000-000000000000",
              text: "変更テスト",
              tcode: "z1_08",
              children: null,
            },
            {
              itemid: "00000000-0000-0000-0000-000000000000",
              text: "Social",
              tcode: "z1_07",
              children: null,
            },
            {
              itemid: "00000000-0000-0000-0000-000000000000",
              text: "変更テストその他収益性向上",
              tcode: "z1_09",
              children: null,
            },
          ],
        },
        {
          cover: require("@/assets/images/c02-01-3.png"),
          link: "/research/detail",
          title: "サイバー人材需給逼迫3",
          catagory: "トレンド",
          publicDate: "2020-01-01 09:12:08",
          summary:
            "将来のサイバー人材を生み出す観点でも、日本は後れを取っている。人材派遣のヒューマンリソシア（東京・新宿）は7月、STEM（科学、技術、工学、数学）分野の卒業者数に関する調査を発表した。対象となる92の国・地域のうち、日本は13位の3万人。インド（114万人）や米国（28万人）のみならず、英国（10万人）やフランス",
          tagModel: [
            {
              itemid: "00000000-0000-0000-0000-000000000000",
              text: "収益性向上",
              tcode: "z2_01",
              children: null,
            },
          ],
        },
        {
          cover: require("@/assets/images/c02-01-4.png"),
          link: "/research/detail",
          title: "サイバー人材需給逼迫4",
          catagory: "トレンド",
          publicDate: "2020-01-01 09:12:08",
          summary:
            "将来のサイバー人材を生み出す観点でも、日本は後れを取っている。人材派遣のヒューマンリソシア（東京・新宿）は7月、STEM（科学、技術、工学、数学）分野の卒業者数に関する調査を発表した。対象となる92の国・地域のうち、日本は13位の3万人。インド（114万人）や米国（28万人）のみならず、英国（10万人）やフランス",
          tagModel: [
            {
              itemid: "00000000-0000-0000-0000-000000000000",
              text: "収益性向上",
              tcode: "z2_01",
              children: null,
            },
          ],
        },
        {
          cover: require("@/assets/images/c02-01-5.png"),
          link: "/research/detail",
          title: "サイバー人材需給逼迫5",
          catagory: "トレンド",
          publicDate: "2020-01-01 09:12:08",
          summary:
            "将来のサイバー人材を生み出す観点でも、日本は後れを取っている。人材派遣のヒューマンリソシア（東京・新宿）は7月、STEM（科学、技術、工学、数学）分野の卒業者数に関する調査を発表した。対象となる92の国・地域のうち、日本は13位の3万人。インド（114万人）や米国（28万人）のみならず、英国（10万人）やフランス...M（科学、技術、工学、数学）分野の卒業者数に関する調査を発表した。対象となる92の国・地域のうち、日本は13位の3万人。インド（114万人）や米国（28万人）のみならず、英国（10万人）やフランス",
          tagModel: [
            {
              itemid: "00000000-0000-0000-0000-000000000000",
              text: "収益性向上",
              tcode: "z2_01",
              children: null,
            },
          ],
        },
        {
          cover: require("@/assets/images/c02-01-6.png"),
          link: "/research/detail",
          title: "サイバー人材需給逼迫6",
          catagory: "ピックアップニュース",
          publicDate: "2020-01-01 09:12:08",
          summary:
            "将来のサイバー人材を生み出す観点でも、日本は後れを取っている。人材派遣のヒューマンリソシア（東京・新宿）は7月、STEM（科学、技術、工学、数学）分野の卒業者数に関する調査を発表した。対象となる92の国・地域のうち、日本は13位の3万人。インド（114万人）や米国（28万人）のみならず、英国（10万人）やフランス...M（科学、技術、工学、数学）分野の卒業者数に関する調査を発表した。対象となる92の国・地域のうち、日本は13位の3万人。インド（114万人）や米国（28万人）のみならず、英国（10万人）やフランス",
          tagModel: [
            {
              itemid: "00000000-0000-0000-0000-000000000000",
              text: "収益性向上",
              tcode: "z2_01",
              children: null,
            },
          ],
        },
        {
          cover: require("@/assets/images/c02-01-7.png"),
          link: "/research/detail",
          title: "サイバー人材需給逼迫7",
          catagory: "トレンド",
          publicDate: "2020-01-01 09:12:08",
          summary:
            "将来のサイバー人材を生み出す観点でも、日本は後れを取っている。人材派遣のヒューマンリソシア（東京・新宿）は7月、STEM（科学、技術、工学、数学）分野の卒業者数に関する調査を発表した。対象となる92の国・地域のうち、日本は13位の3万人。インド（114万人）や米国（28万人）のみならず、英国（10万人）やフランス",
          tagModel: [
            {
              itemid: "00000000-0000-0000-0000-000000000000",
              text: "収益性向上",
              tcode: "z2_01",
              children: null,
            },
          ],
        },
        {
          cover: require("@/assets/images/c02-01-8.png"),
          link: "/research/detail",
          title: "サイバー人材需給逼迫8",
          catagory: "トレンド",
          publicDate: "2020-01-01 09:12:08",
          summary:
            "将来のサイバー人材を生み出す観点でも、日本は後れを取っている。人材派遣のヒューマンリソシア（東京・新宿）は7月、STEM（科学、技術、工学、数学）分野の卒業者数に関する調査を発表した。対象となる92の国・地域のうち、日本は13位の3万人。インド（114万人）や米国（28万人）のみならず、英国（10万人）やフランス",
          tagModel: [
            {
              itemid: "00000000-0000-0000-0000-000000000000",
              text: "収益性向上",
              tcode: "z2_01",
              children: null,
            },
          ],
        },
        {
          cover: require("@/assets/images/c02-01-9.png"),
          link: "/research/detail",
          title: "サイバー人材需給逼迫9",
          catagory: "トレンド",
          publicDate: "2020-01-01 09:12:08",
          summary:
            "将来のサイバー人材を生み出す観点でも、日本は後れを取っている。人材派遣のヒューマンリソシア（東京・新宿）は7月、STEM（科学、技術、工学、数学）分野の卒業者数に関する調査を発表した。対象となる92の国・地域のうち、日本は13位の3万人。インド（114万人）や米国（28万人）のみならず、英国（10万人）やフランス",
          tagModel: [
            {
              itemid: "00000000-0000-0000-0000-000000000000",
              text: "収益性向上",
              tcode: "z2_01",
              children: null,
            },
          ],
        },
        {
          cover: require("@/assets/images/c03-02-1.png"),
          link: "/research/detail",
          title: "サイバー人材需給逼迫10",
          catagory: "トレンド",
          publicDate: "2020-01-01 09:12:08",
          summary:
            "将来のサイバー人材を生み出す観点でも、日本は後れを取っている。人材派遣のヒューマンリソシア（東京・新宿）は7月、STEM（科学、技術、工学、数学）分野の卒業者数に関する調査を発表した。対象となる92の国・地域のうち、日本は13位の3万人。インド（114万人）や米国（28万人）のみならず、英国（10万人）やフランス",
          tagModel: [
            {
              itemid: "00000000-0000-0000-0000-000000000000",
              text: "収益性向上",
              tcode: "z2_01",
              children: null,
            },
          ],
        },
      ];
    } else {
      const catagoryID = parse("catagoryID", option.url);
      switch (catagoryID) {
        case "1":
          list = [
            {
              cover: require("@/assets/images/c02-01-1.png"),
              link: "/research/detail",
              title: "サイバー人材需給逼迫1",
              catagory: "トレンド",
              publicDate: "2020-01-01 09:12:08",
              summary:
                "将来のサイバー人材を生み出す観点でも、日本は後れを取っている。人材派遣のヒューマンリソシア（東京・新宿）は7月、STEM（科学、技術、工学、数学）分野の卒業者数に関する調査を発表した。対象となる92の国・地域のうち、日本は13位の3万人。インド（114万人）や米国（28万人）のみならず、英国（10万人）やフランス...M（科学、技術、工学、数学）分野の卒業者数に関する調査を発表した。対象となる92の国・地域のうち、日本は13位の3万人。インド（114万人）や米国（28万人）のみならず、英国（10万人）やフランス",
              tagModel: [
                {
                  itemid: "00000000-0000-0000-0000-000000000000",
                  text:
                    "その他変更テストその他収益性向上変更テストその他収益性向上",
                  tcode: "z1_01",
                  children: null,
                },
                {
                  itemid: "00000000-0000-0000-0000-000000000000",
                  text: "変更テスト",
                  tcode: "z1_08",
                  children: null,
                },
                {
                  itemid: "00000000-0000-0000-0000-000000000000",
                  text: "Social",
                  tcode: "z1_07",
                  children: null,
                },
                {
                  itemid: "00000000-0000-0000-0000-000000000000",
                  text: "変更テストその他収益性向上",
                  tcode: "z1_09",
                  children: null,
                },
              ],
            },
            {
              cover: require("@/assets/images/c02-01-2.png"),
              link: "/research/detail",
              title: "サイバー人材需給逼迫2",
              catagory: "ピックアップニュース",
              publicDate: "2020-01-01 09:12:08",
              summary:
                "将来のサイバー人材を生み出す観点でも、日本は後れを取っている。人材派遣のヒューマンリソシア（東京・新宿）は7月、STEM（科学、技術、工学、数学）分野の卒業者数に関する調査を発表した。対象となる92の国・地域のうち、日本は13位の3万人。インド（114万人）や米国（28万人）のみならず、英国（10万人）やフランス...M（科学、技術、工学、数学）分野の卒業者数に関する調査を発表した。対象となる92の国・地域のうち、日本は13位の3万人。インド（114万人）や米国（28万人）のみならず、英国（10万人）やフランス",
              tagModel: [
                {
                  itemid: "00000000-0000-0000-0000-000000000000",
                  text: "収益性向上",
                  tcode: "z2_01",
                  children: null,
                },
                {
                  itemid: "00000000-0000-0000-0000-000000000000",
                  text: "変更テスト",
                  tcode: "z1_08",
                  children: null,
                },
                {
                  itemid: "00000000-0000-0000-0000-000000000000",
                  text: "Social",
                  tcode: "z1_07",
                  children: null,
                },
                {
                  itemid: "00000000-0000-0000-0000-000000000000",
                  text: "変更テストその他収益性向上",
                  tcode: "z1_09",
                  children: null,
                },
              ],
            },
            {
              cover: require("@/assets/images/c02-01-3.png"),
              link: "/research/detail",
              title: "サイバー人材需給逼迫3",
              catagory: "トレンド",
              publicDate: "2020-01-01 09:12:08",
              summary:
                "将来のサイバー人材を生み出す観点でも、日本は後れを取っている。人材派遣のヒューマンリソシア（東京・新宿）は7月、STEM（科学、技術、工学、数学）分野の卒業者数に関する調査を発表した。対象となる92の国・地域のうち、日本は13位の3万人。インド（114万人）や米国（28万人）のみならず、英国（10万人）やフランス",
              tagModel: [
                {
                  itemid: "00000000-0000-0000-0000-000000000000",
                  text: "収益性向上",
                  tcode: "z2_01",
                  children: null,
                },
              ],
            },
            {
              cover: require("@/assets/images/c02-01-4.png"),
              link: "/research/detail",
              title: "サイバー人材需給逼迫4",
              catagory: "トレンド",
              publicDate: "2020-01-01 09:12:08",
              summary:
                "将来のサイバー人材を生み出す観点でも、日本は後れを取っている。人材派遣のヒューマンリソシア（東京・新宿）は7月、STEM（科学、技術、工学、数学）分野の卒業者数に関する調査を発表した。対象となる92の国・地域のうち、日本は13位の3万人。インド（114万人）や米国（28万人）のみならず、英国（10万人）やフランス",
              tagModel: [
                {
                  itemid: "00000000-0000-0000-0000-000000000000",
                  text: "収益性向上",
                  tcode: "z2_01",
                  children: null,
                },
              ],
            },
          ];
          break;
        case "2":
          list = [
            {
              cover: require("@/assets/images/c02-01-5.png"),
              link: "/research/detail",
              title: "サイバー人材需給逼迫5",
              catagory: "トレンド",
              publicDate: "2020-01-01 09:12:08",
              summary:
                "将来のサイバー人材を生み出す観点でも、日本は後れを取っている。人材派遣のヒューマンリソシア（東京・新宿）は7月、STEM（科学、技術、工学、数学）分野の卒業者数に関する調査を発表した。対象となる92の国・地域のうち、日本は13位の3万人。インド（114万人）や米国（28万人）のみならず、英国（10万人）やフランス...M（科学、技術、工学、数学）分野の卒業者数に関する調査を発表した。対象となる92の国・地域のうち、日本は13位の3万人。インド（114万人）や米国（28万人）のみならず、英国（10万人）やフランス",
              tagModel: [
                {
                  itemid: "00000000-0000-0000-0000-000000000000",
                  text:
                    "その他変更テストその他収益性向上変更テストその他収益性向上",
                  tcode: "z1_01",
                  children: null,
                },
                {
                  itemid: "00000000-0000-0000-0000-000000000000",
                  text: "変更テスト",
                  tcode: "z1_08",
                  children: null,
                },
                {
                  itemid: "00000000-0000-0000-0000-000000000000",
                  text: "Social",
                  tcode: "z1_07",
                  children: null,
                },
                {
                  itemid: "00000000-0000-0000-0000-000000000000",
                  text: "変更テストその他収益性向上",
                  tcode: "z1_09",
                  children: null,
                },
              ],
            },
            {
              cover: require("@/assets/images/c02-01-6.png"),
              link: "/research/detail",
              title: "サイバー人材需給逼迫6",
              catagory: "ピックアップニュース",
              publicDate: "2020-01-01 09:12:08",
              summary:
                "将来のサイバー人材を生み出す観点でも、日本は後れを取っている。人材派遣のヒューマンリソシア（東京・新宿）は7月、STEM（科学、技術、工学、数学）分野の卒業者数に関する調査を発表した。対象となる92の国・地域のうち、日本は13位の3万人。インド（114万人）や米国（28万人）のみならず、英国（10万人）やフランス...M（科学、技術、工学、数学）分野の卒業者数に関する調査を発表した。対象となる92の国・地域のうち、日本は13位の3万人。インド（114万人）や米国（28万人）のみならず、英国（10万人）やフランス",
              tagModel: [
                {
                  itemid: "00000000-0000-0000-0000-000000000000",
                  text:
                    "その他変更テストその他収益性向上変更テストその他収益性向上",
                  tcode: "z1_01",
                  children: null,
                },
                {
                  itemid: "00000000-0000-0000-0000-000000000000",
                  text: "変更テスト",
                  tcode: "z1_08",
                  children: null,
                },
                {
                  itemid: "00000000-0000-0000-0000-000000000000",
                  text: "Social",
                  tcode: "z1_07",
                  children: null,
                },
                {
                  itemid: "00000000-0000-0000-0000-000000000000",
                  text: "変更テストその他収益性向上",
                  tcode: "z1_09",
                  children: null,
                },
              ],
            },
          ];
          break;
        case "3":
          list = [
            {
              cover: require("@/assets/images/c02-01-7.png"),
              link: "/research/detail",
              title: "サイバー人材需給逼迫7",
              catagory: "トレンド",
              publicDate: "2020-01-01 09:12:08",
              summary:
                "将来のサイバー人材を生み出す観点でも、日本は後れを取っている。人材派遣のヒューマンリソシア（東京・新宿）は7月、STEM（科学、技術、工学、数学）分野の卒業者数に関する調査を発表した。対象となる92の国・地域のうち、日本は13位の3万人。インド（114万人）や米国（28万人）のみならず、英国（10万人）やフランス",
              tagModel: [
                {
                  itemid: "00000000-0000-0000-0000-000000000000",
                  text:
                    "その他変更テストその他収益性向上変更テストその他収益性向上",
                  tcode: "z1_01",
                  children: null,
                },
                {
                  itemid: "00000000-0000-0000-0000-000000000000",
                  text: "変更テスト",
                  tcode: "z1_08",
                  children: null,
                },
                {
                  itemid: "00000000-0000-0000-0000-000000000000",
                  text: "Social",
                  tcode: "z1_07",
                  children: null,
                },
                {
                  itemid: "00000000-0000-0000-0000-000000000000",
                  text: "変更テストその他収益性向上",
                  tcode: "z1_09",
                  children: null,
                },
              ],
            },
            {
              cover: require("@/assets/images/c02-01-8.png"),
              link: "/research/detail",
              title: "サイバー人材需給逼迫8",
              catagory: "トレンド",
              publicDate: "2020-01-01 09:12:08",
              summary:
                "将来のサイバー人材を生み出す観点でも、日本は後れを取っている。人材派遣のヒューマンリソシア（東京・新宿）は7月、STEM（科学、技術、工学、数学）分野の卒業者数に関する調査を発表した。対象となる92の国・地域のうち、日本は13位の3万人。インド（114万人）や米国（28万人）のみならず、英国（10万人）やフランス",
              tagModel: [
                {
                  itemid: "00000000-0000-0000-0000-000000000000",
                  text:
                    "その他変更テストその他収益性向上変更テストその他収益性向上",
                  tcode: "z1_01",
                  children: null,
                },
                {
                  itemid: "00000000-0000-0000-0000-000000000000",
                  text: "変更テスト",
                  tcode: "z1_08",
                  children: null,
                },
                {
                  itemid: "00000000-0000-0000-0000-000000000000",
                  text: "Social",
                  tcode: "z1_07",
                  children: null,
                },
                {
                  itemid: "00000000-0000-0000-0000-000000000000",
                  text: "変更テストその他収益性向上",
                  tcode: "z1_09",
                  children: null,
                },
              ],
            },
            {
              cover: require("@/assets/images/c02-01-9.png"),
              link: "/research/detail",
              title: "サイバー人材需給逼迫9",
              catagory: "トレンド",
              publicDate: "2020-01-01 09:12:08",
              summary:
                "将来のサイバー人材を生み出す観点でも、日本は後れを取っている。人材派遣のヒューマンリソシア（東京・新宿）は7月、STEM（科学、技術、工学、数学）分野の卒業者数に関する調査を発表した。対象となる92の国・地域のうち、日本は13位の3万人。インド（114万人）や米国（28万人）のみならず、英国（10万人）やフランス",
              tagModel: [
                {
                  itemid: "00000000-0000-0000-0000-000000000000",
                  text:
                    "その他変更テストその他収益性向上変更テストその他収益性向上",
                  tcode: "z1_01",
                  children: null,
                },
                {
                  itemid: "00000000-0000-0000-0000-000000000000",
                  text: "変更テスト",
                  tcode: "z1_08",
                  children: null,
                },
                {
                  itemid: "00000000-0000-0000-0000-000000000000",
                  text: "Social",
                  tcode: "z1_07",
                  children: null,
                },
                {
                  itemid: "00000000-0000-0000-0000-000000000000",
                  text: "変更テストその他収益性向上",
                  tcode: "z1_09",
                  children: null,
                },
              ],
            },
            {
              cover: require("@/assets/images/c03-02-1.png"),
              link: "/research/detail",
              title: "サイバー人材需給逼迫10",
              catagory: "トレンド",
              publicDate: "2020-01-01 09:12:08",
              summary:
                "将来のサイバー人材を生み出す観点でも、日本は後れを取っている。人材派遣のヒューマンリソシア（東京・新宿）は7月、STEM（科学、技術、工学、数学）分野の卒業者数に関する調査を発表した。対象となる92の国・地域のうち、日本は13位の3万人。インド（114万人）や米国（28万人）のみならず、英国（10万人）やフランス",
              tagModel: [
                {
                  itemid: "00000000-0000-0000-0000-000000000000",
                  text:
                    "その他変更テストその他収益性向上変更テストその他収益性向上",
                  tcode: "z1_01",
                  children: null,
                },
                {
                  itemid: "00000000-0000-0000-0000-000000000000",
                  text: "変更テスト",
                  tcode: "z1_08",
                  children: null,
                },
                {
                  itemid: "00000000-0000-0000-0000-000000000000",
                  text: "Social",
                  tcode: "z1_07",
                  children: null,
                },
                {
                  itemid: "00000000-0000-0000-0000-000000000000",
                  text: "変更テストその他収益性向上",
                  tcode: "z1_09",
                  children: null,
                },
              ],
            },
          ];
          break;

        default:
          break;
      }
    }

    return {
      code: 200,
      msg: "操作成功",
      data: {
        totalCount: list.length,
        list,
      },
    };
  },
};
